import Branch from "./assets/Branch";
import Course from "./assets/Course";
import Teacher from "./assets/Teacher";
import News from "./assets/News";
import Test from "./assets/Test";
import SettingsIcon from "@mui/icons-material/Settings";
import CategoryIcon from "@mui/icons-material/Category";
import ListRoundedIcon from "@mui/icons-material/ListRounded";
import InfoIcon from "@mui/icons-material/Info";
import CollectionsIcon from "@mui/icons-material/Collections";
import LockResetIcon from "@mui/icons-material/LockReset";
import AssignmentIcon from "@mui/icons-material/Assignment";

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;
export const sidebarWidth = "275px";

export const SIDEBAR_LIST = [
  {
    key: "1",
    icon: <ListRoundedIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Mahsulotlar",
    path: `/product?page=${DEFAULT_PAGE}&limit=${DEFAULT_LIMIT}`,
  },
  {
    key: "2",
    icon: <CategoryIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Kategoriya",
    path: `/category?page=${DEFAULT_PAGE}&limit=${DEFAULT_LIMIT}`,
  },
  {
    key: "3",
    icon: <AssignmentIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Arizalar",
    path: `/appeal?page=${DEFAULT_PAGE}&limit=${DEFAULT_LIMIT}`,
  },
  {
    key: "4",
    icon: <InfoIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Biz haqimizda",
    path: `/about?page=${DEFAULT_PAGE}&limit=${DEFAULT_LIMIT}`,
  },
  {
    key: "5",
    icon: <CollectionsIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Bannerlar",
    path: `/banner?page=${DEFAULT_PAGE}&limit=${DEFAULT_LIMIT}`,
  },
  {
    key: "6",
    icon: <LockResetIcon style={{ color: "#3672B9", fontSize: "1.5rem" }} />,
    text: "Parolni almashtirish",
    path: `/update`,
  },
];
